import { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import {Link, useParams} from 'react-router-dom';
import PermissionErrorPage from '../pages/shared/permissionError';
import Button from 'react-bootstrap/Button';
import '../styles/components/features/qefficiency.css';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
  import { Bar } from 'react-chartjs-2';
  import { faker } from '@faker-js/faker';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);


export default function QEfficiency() {
  
    const [attempt, setAttempt] = useState([]);
    const [correct, setCorrect] = useState([]); //number of correct submissions for graph
    const { id } = useParams(); //question number variable for x axis
    const labels = ['Question' + id]
    var incorrect = attempt - correct; //number of incorrect submissions for graph


    const attempts = () => {
        fetch(process.env.REACT_APP_API_URL+"/api/numTotalSubmissions/"+id, {
          method: 'GET', 
          headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
          }
        })
            .then((response) => response.json())
            .then((json) => {
                setAttempt(json[0].n);
            });
    };
    useEffect(()=>{
        attempts();
    }, []);
    const correctAttempts = () => {
        fetch(process.env.REACT_APP_API_URL+"/api/correctSubmissions/"+id, {
          method: 'GET', 
          headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
          }
        })
            .then((response) => response.json())
            .then((json) => {
                setCorrect(json[0].n);
            });
    };
    useEffect(()=>{
        correctAttempts();
    }, []);


    const data = {
      labels,
      datasets: [
        {
          label: 'Correct',
          data: [correct],
          backgroundColor: 'rgba(53, 162, 235, 0.5)',
        },
        {
          label: 'Incorrect',
          data: [incorrect],
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
      ],
    };
    
    const options = {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: 'Question Efficiency of Question ' + id ,
          },
        },
      };
    return (
      <div>
      {(localStorage.getItem('roleData') == 'instructor') ? (
    <>
        <div className="qefficiency-container">
            <h1 className="qefficiency-heading">Question Efficiency of Question {id}</h1>
            <div className="qefficiency-chart-wrapper">
                <Bar options={options} data={data} />
            </div>
            <Link to="/questionTable">
                <Button className="qefficiency-back-button">Go Back to Questions</Button>
            </Link>
        </div>
    </>
  ) : (<PermissionErrorPage/>
  )}
  </div>
    )
}